export enum Calculator {
    PORCENTAGE = 1,
    QUANTITY = 2,
    PERSONALIZED = 3
}

export const MSI_OPTIONS = [3, 6, 9, 12] as const;
export type MsiOption = typeof MSI_OPTIONS[number];

const MSI_MIN_INSTALLMENT = 500;

export const MSI_MIN_AMOUNT: Record<MsiOption, number> = {
    3: 3 * MSI_MIN_INSTALLMENT,
    6: 6 * MSI_MIN_INSTALLMENT,
    9: 9 * MSI_MIN_INSTALLMENT,
    12: 12 * MSI_MIN_INSTALLMENT,
};
